import ReactTooltip from "react-tooltip";
import { QuestionCircle } from "../Icons/general-interface-1";
import styles from "./index.module.scss";

type PropsType = {
  id: string;
  title?: string;
  content: string;
  place?: "top" | "right" | "bottom" | "left";
  type?: "dark" | "success" | "warning" | "error" | "info" | "light";
  links?: Array<{ id: string, text: string; href: string }>;
};

/**
 * Do not keep this component inside a <p> tag, or there will be a warning.
 */
const Tooltip = ({
  id,
  title,
  content,
  type = "info",
  place = "top",
  links,
}: PropsType) => {
  return (
    <span className={styles.wrapper}>
      <button
        data-tip
        data-for={id}
        type="button"
        className={styles.button}
        aria-label="more info"
      >
        <QuestionCircle width="16px" height="16px" />
      </button>
      <ReactTooltip
        wrapper="span"
        id={id}
        type={type}
        place={place}
        effect="solid"
        multiline
        backgroundColor={styles.grey_500}
        className={styles.tip}
        role="status"
        aria-live="polite"
        eventOff="blur"
        delayUpdate={links ? 100 : 0}
        delayHide={links ? 100 : 0}
      >
        <>
          {title && <span className={styles.title}>{title}</span>}
          <span className={styles.content}>{content}</span>
          {links &&
            links.map((link) => {
              return (
                <span key={`${id}-${link.id}`}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.links}
                  >
                    {link.text}
                  </a>
                  <br />
                </span>
              );
            })}
        </>
      </ReactTooltip>
    </span>
  );
};

export default Tooltip;
